// =================================================================
// 0. GESTIÓN GLOBAL E INICIALIZACIÓN
// =================================================================
let globalUpsellManager = null;

/**
 * Inicializa el UpsellManager de forma segura. Si ya existe, 
 * actualiza las referencias del DOM y sincroniza el estado.
 */
async function initializeUpsellManager() {
    const upsellElement = document.querySelector('.cart-upsell');
    if (!upsellElement) return;

    // Si el manager no existe, crearlo.
    if (!globalUpsellManager) {
        globalUpsellManager = new UpsellManager(upsellElement);
    } else {
        // Si existe, solo actualizar las referencias al nuevo DOM.
        globalUpsellManager.upsellElement = upsellElement;
        globalUpsellManager.checkbox = upsellElement.querySelector('#upsell-product-toggle');
        globalUpsellManager.productForm = upsellElement.querySelector('product-form form');
    }

    // Sincronizar el estado visual del checkbox con el carrito real (CRÍTICO)
    if (globalUpsellManager.checkbox && globalUpsellManager.productForm) {
        await globalUpsellManager.checkInitialState();
    }
}

// -----------------------------------------------------------------
// 1. CLASE PRINCIPAL CORREGIDA (UpsellManager)
// -----------------------------------------------------------------
class UpsellManager {
    // 🟢 CORRECCIÓN: El constructor ahora recibe el elemento y NO añade listeners.
    constructor(element) {
        this.upsellElement = element;
        if (!this.upsellElement || !this.upsellElement.dataset.id) return;

        this.checkbox = this.upsellElement.querySelector('#upsell-product-toggle');
        this.productForm = this.upsellElement.querySelector('product-form form');
        this.isDisabled = false;

        // La comprobación inicial se hace en initializeUpsellManager
    }

    resetToDefault() {
        this.upsellElement.dataset.selected = 'true';
        this.checkbox.checked = true;
        this.isDisabled = false;
    }

    // 🟢 CORRECCIÓN: El listener se delega al documento (ver más abajo), este es el manejador.
    async handleToggle(event) {
        const isSelected = event.target.checked;
        if (isSelected) {
            await this.addToCart();
        } else {
            await this.removeFromCart();
        }
    }

    async checkInitialState() {
        if (!this.upsellElement.dataset.id) return;
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            const hasUpsell = cart.items.some(item => 
                item.variant_id == this.upsellElement.dataset.id && item.properties?._upsell
            );
            this.upsellElement.dataset.selected = hasUpsell.toString();
            this.checkbox.checked = hasUpsell;
            this.isDisabled = false;
        } catch {
            this.upsellElement.dataset.selected = 'false';
            this.checkbox.checked = false;
            this.isDisabled = false;
        }
    }

    async addToCart() {
        if (!this.upsellElement.dataset.id || this.isDisabled) return;

        this.isDisabled = true;
        const formData = new FormData(this.productForm);
        // Asegurar que quantity=1 se añade si falta (buena práctica)
        if (!formData.has('quantity')) {
             formData.append('quantity', 1);
        }
        formData.append('properties[_upsell]', 'true');

        try {
            await fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            });
            this.upsellElement.dataset.selected = 'true';
            this.checkbox.checked = true;
            await this.refreshCartDrawer();
        } catch {
            this.checkbox.checked = false;
            this.upsellElement.dataset.selected = 'false';
        }
        this.isDisabled = false;
    }

    async removeFromCart() {
        if (!this.upsellElement.dataset.id || this.isDisabled) return;

        this.isDisabled = true;
        
        // 🟢 CORRECCIÓN DEL PARPADEO: Forzar el estado visual desmarcado inmediatamente.
        this.checkbox.checked = false; 

        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            
            const upsellItems = cart.items.filter(item => 
                item.variant_id == this.upsellElement.dataset.id && item.properties?._upsell
            );

            if (upsellItems.length > 0) {
                for (const item of upsellItems) {
                    await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            id: item.key,
                            quantity: 0
                        })
                    });
                }
            }
            this.upsellElement.dataset.selected = 'false';
            
            await this.refreshCartDrawer();
        } catch {
            // Revertir el estado visual en caso de fallo de la red/servidor
            this.checkbox.checked = true;
            this.upsellElement.dataset.selected = 'true';
        }
        this.isDisabled = false;
    }

    async refreshCartDrawer() {
        try {
            const response = await fetch('/cart?section_id=cart-drawer');
            const html = await response.text();
            const parser = new DOMParser();
            const newDoc = parser.parseFromString(html, 'text/html');
            const newItems = newDoc.querySelector('.cart-drawer__content, .drawer__inner');
            const currentItems = document.querySelector('.cart-drawer__content, .drawer__inner');

            if (newItems && currentItems) {
                currentItems.innerHTML = newItems.innerHTML;
                
                // 🟢 CORRECCIÓN: Llamar a la inicialización para actualizar referencias y estado.
                await initializeUpsellManager(); 
            }
        } catch {}
    }
}


// -----------------------------------------------------------------
// 2. DELEGACIÓN DE EVENTOS (Reemplaza el listener del constructor)
// -----------------------------------------------------------------
document.addEventListener('change', (e) => {
    // Escucha todos los 'change' y solo actúa si es el checkbox del upsell y el manager existe
    if (!globalUpsellManager || !e.target.matches('#upsell-product-toggle')) {
        return;
    }

    globalUpsellManager.handleToggle(e);
});


// -----------------------------------------------------------------
// 3. FUNCIONES GLOBALES (Correcciones de Instanciación)
// -----------------------------------------------------------------
initializeUpsellManager(); // Llamada de inicialización al cargar la página

function monitorCartChanges() {
    setInterval(async () => {
        const upsellElement = document.querySelector('.cart-upsell');
        // Usar el manager global para las comprobaciones
        if (!upsellElement || !upsellElement.dataset.id || !globalUpsellManager) return; 

        const manager = globalUpsellManager;
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const regularItems = cart.items.filter(item => !item.properties?._upsell);
        const upsellItems = cart.items.filter(item => 
            item.variant_id == upsellElement.dataset.id && item.properties?._upsell
        );

        // Solo eliminamos el upsell si es el único ítem
        if (cart.items.length === 1 && upsellItems.length === 1 && !regularItems.length) {
            await manager.removeFromCart();
        }
    }, 1000);

    document.addEventListener('click', e => {
        if (e.target.closest('.cart-drawer, .cart')) {
            setTimeout(() => {
                // 🟢 CORRECCIÓN: Llamamos a initializeUpsellManager() para re-sincronizar el DOM.
                initializeUpsellManager(); 
            }, 1000);
        }
    });
}

monitorCartChanges();

function interceptAddToCart() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        form.addEventListener('submit', () => setTimeout(autoAddUpsellIfNeeded, 500));
    });
    document.querySelectorAll('[data-add-to-cart], .btn-product-add, .product-form__cart-submit').forEach(button => {
        button.addEventListener('click', () => setTimeout(autoAddUpsellIfNeeded, 500));
    });
}

async function autoAddUpsellIfNeeded() {
    const upsellElement = document.querySelector('.cart-upsell');
    // Usar el manager global para las comprobaciones
    if (!upsellElement || !upsellElement.dataset.id || !globalUpsellManager) return; 

    const isSelected = upsellElement.dataset.selected === 'true';
    const variantId = upsellElement.dataset.id;

    const response = await fetch('/cart.js');
    const cart = await response.json();
    const regularItems = cart.items.filter(item => !item.properties?._upsell);
    const hasUpsell = cart.items.some(item => item.variant_id == variantId && item.properties?._upsell);

    if (regularItems.length > 0 && !hasUpsell && isSelected) {
        // 🟢 CORRECCIÓN: Usar el manager global
        await globalUpsellManager.addToCart(); 
    }
}

interceptAddToCart();


// -----------------------------------------------------------------
// 4. CLASES DE ELEMENTOS PERSONALIZADOS (CartDrawer y CartDrawerItems)
// -----------------------------------------------------------------
// NOTA: Estas clases no necesitan el ajuste de estado del upsell, solo la inicialización final.

class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

        setTimeout(() => {
            this.classList.add('animate', 'active');
        });


        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = this.classList.contains('is-empty')
                    ? this.querySelector('.drawer__inner-empty')
                    : document.getElementById('CartDrawer');
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                if (typeof trapFocus !== 'undefined') {
                    trapFocus(containerToTrapFocusOn, focusElement);
                }
            },
            { once: true }
        );

        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        if (typeof removeTrapFocus !== 'undefined') {
            removeTrapFocus(this.activeElement);
        }
        document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute('role', 'button');
        cartDrawerNote.setAttribute('aria-expanded', 'false');

        if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
            cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
        }

        cartDrawerNote.addEventListener('click', (event) => {
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });

        if (typeof onKeyUpEscape !== 'undefined') {
            cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
        }
    }

    renderContents(parsedState) {
        this.querySelector('.drawer__inner').classList.contains('is-empty') &&
            this.querySelector('.drawer__inner').classList.remove('is-empty');
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });

        setTimeout(async () => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            
            // 🟢 CORRECCIÓN: Llamar a la inicialización después de renderizar el nuevo HTML.
            await initializeUpsellManager(); 
            
            this.open();
        });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer',
            },
            {
                id: 'cart-icon-bubble',
            },
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
        ];
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);